module.exports = __webpack_public_path__ + "static/media/3DC58360-F827-4EBA-885E-C894DA85F2CF.0656d1ff.PNG";